import { Clock, RefreshCw } from "lucide-react";
import { Button } from "../ui/button";
interface OTPTimerProps {
  timeLeft: number;
  canResend: boolean;
  onResend: () => void;
  isBlocked?: boolean;
}
export const OTPTimer = ({ 
  timeLeft, 
  canResend, 
  onResend, 
  isBlocked = false 
}: OTPTimerProps) => {
  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };
  const getTimerColor = (): string => {
    if (isBlocked) return 'text-red-600';
    if (timeLeft <= 10) return 'text-warning';
    return 'text-gray-600';
  };
  const getTimerMessage = (): string => {
    if (isBlocked) {
      return `Account temporarily blocked. Try again in ${formatTime(timeLeft)}`;
    }
    if (canResend) {
      return "Didn't receive the code?";
    }
    return `Resend code in ${formatTime(timeLeft)}`;
  };
  return (
    <div className="text-center space-y-3">
      {/* Timer Display */}
      <div className="flex items-center justify-center gap-2">
        <Clock className={`w-4 h-4 ${getTimerColor()}`} />
        <span className={`text-sm font-medium ${getTimerColor()}`}>
          {getTimerMessage()}
        </span>
      </div>
      {/* Resend Button */}
      {canResend && !isBlocked && (
        <Button
          onClick={onResend}
          variant="outline"
          className="text-primary-blue border-primary-blue hover:bg-blue-50 font-semibold"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Resend OTP
        </Button>
      )}
      {/* Additional Info */}
      <div className="text-xs text-gray-500 space-y-1">
        <p>Code expires in 10 minutes</p>
        {!isBlocked && (
          <p>Check your spam folder if you don&apos;t see the message</p>
        )}
      </div>
    </div>
  );
};